import { render, staticRenderFns } from "./PcFilePreview.vue?vue&type=template&id=67806bd2&scoped=true&"
import script from "./PcFilePreview.vue?vue&type=script&lang=js&"
export * from "./PcFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./PcFilePreview.vue?vue&type=style&index=0&id=67806bd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67806bd2",
  null
  
)

export default component.exports